import React from 'react';
import PropTypes from 'prop-types';
import emptyFunction from '@avtechsoftware/ra-javascript-utilities/src/utilities/EmptyFunction';
import OrderPaymentDisplayType from '../OrderPaymentDisplayType';

function BasicOrderInformation({
  orderNumber,
  orderStatus,
  billingStatus,
  orderPlacedOn,
  shippingMethod,
  loadError,
  shipmentList,
  onTrackClick,
}) {
  /* istanbul ignore next */
  const renderPaymentStatus = (orderPaymentStatusType) => {
    switch (orderPaymentStatusType) {
      case OrderPaymentDisplayType.CANCELLED:
        return <>Cancelled</>;
      case OrderPaymentDisplayType.CLOSED:
        return <>Closed</>;
      case OrderPaymentDisplayType.REFUNDED:
        return <>Refunded</>;
      case OrderPaymentDisplayType.PAID:
        return <>Paid</>;
      case OrderPaymentDisplayType.OPEN:
        return <>Open</>;
      default:
        return <></>;
    }
  };
  return (
    <div className="card bg-light" style={{ minHeight: '4rem' }}>
      <div className="card-body">
        {!loadError && (
          <h5 className="card-title">
            Order Number:
            {' '}
            {orderNumber}
          </h5>
        )}
        <div className="card-text">
          {
            !loadError ? (
              <ul className="list-unstyled">
                <li>
                  <b>Order Status:</b>
                  {' '}
                  {orderStatus}
                </li>
                <li>
                  <b>Billing Status:</b>
                  {' '}
                  {renderPaymentStatus(billingStatus)}
                </li>
                <li>
                  <b>Order Placed On:</b>
                  {' '}
                  {orderPlacedOn}
                </li>
                <li>
                  <b>Shipping Method:</b>
                  {' '}
                  {shippingMethod}
                </li>
                <br />
                {shipmentList.length > 0 && (
                  <li>
                    <b>Tracking Numbers:</b>
                    {shipmentList.map(((shipment, index) => (
                      <div key={index}>
                        <button
                          type="button"
                          className="btn btn-sm btn-link mb-1 pl-0"
                          onClick={() => onTrackClick(shipment.id)}
                        >
                          {shipment.trackingNumber}
                        </button>
                      </div>
                    )))}
                  </li>
                )}
              </ul>
            )
              : (
                <p className="text-danger">
                  Order Not found. Try again here:
                  {' '}
                  <a href="/p/order-quote/search">Order Lookup</a>
                  .
                </p>
              )
          }
        </div>
        <small href="#" className="card-link">More details available on your Room Alert Account.</small>
      </div>
    </div>
  );
}

BasicOrderInformation.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  orderStatus: PropTypes.string.isRequired,
  billingStatus: PropTypes.number.isRequired,
  orderPlacedOn: PropTypes.string.isRequired,
  shippingMethod: PropTypes.string.isRequired,
  loadError: PropTypes.bool.isRequired,
  shipmentList: PropTypes.arrayOf(PropTypes.shape({ trackingNumber: PropTypes.string })),
  onTrackClick: PropTypes.func,
};

BasicOrderInformation.defaultProps = {
  onTrackClick: emptyFunction,
  shipmentList: [],
};

export default BasicOrderInformation;
